import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSelector = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-selector absolute text-retta-green text-xl right-6 top-6">
      {(currentLanguage === "en" ||
        currentLanguage === "en-GB" ||
        currentLanguage === "en-US") && (
        <>
          <button
            className="pr-2 hover:underline"
            type="button"
            onClick={() => changeLanguage("fi")}
          >
            FI
          </button>
          /
          <button
            className="pl-2 hover:underline"
            type="button"
            onClick={() => changeLanguage("sv")}
          >
            SV
          </button>
        </>
      )}
      {(currentLanguage === "fi" || currentLanguage === "fi-FI") && (
        <>
          <button
            className="pr-2 hover:underline"
            type="button"
            onClick={() => changeLanguage("en")}
          >
            EN
          </button>
          /
          <button
            className="pl-2 hover:underline"
            type="button"
            onClick={() => changeLanguage("sv")}
          >
            SV
          </button>
        </>
      )}
      {(currentLanguage === "sv" || currentLanguage === "sv-SV") && (
        <>
          <button
            className="pr-2 hover:underline"
            type="button"
            onClick={() => changeLanguage("en")}
          >
            EN
          </button>
          /
          <button
            className="pl-2 hover:underline"
            type="button"
            onClick={() => changeLanguage("fi")}
          >
            FI
          </button>
        </>
      )}
    </div>
  );
};

export default LanguageSelector;
